import {getWakeletUrl, isProd, isStaging} from "../../env/env";
import {nanoid} from "nanoid";

export const isUnsupportedProvider = (provider: string): boolean => {
  const isSupported = provider === "clever" || provider === "classlink";
  return !isSupported;
};

export const createCleverUri = () => {
  const u = new URL(getCleverHost());
  u.searchParams.set("client_id", "f77f0899e946395c69ed");
  u.searchParams.set("redirect_uri", encodeURI(getWakeletUrl("/i/clever/redirect")));
  u.searchParams.set("response_type", "code");
  u.searchParams.set("state", `alpha-accounts-${nanoid()}`);
  return u;
};

const getCleverHost = () => {
  if (isProd() || isStaging()) {
    return "https://clever.com/oauth/authorize";
  }
  return "http://localhost.clever:1236";
}

export const createClasslinkUri = () => {
  const u = new URL(getClasslinkHost());
  u.searchParams.set("client_id", "c1641310905358fab65edbe4bb6b4b2c46781840a8cf");
  u.searchParams.set("redirect_uri", encodeURI(getWakeletUrl("/i/classlink/redirect")));
  u.searchParams.set("response_type", "code")
  u.searchParams.set("scope", "profile,openid")
  u.searchParams.set("state", `alpha-accounts-${nanoid()}`);
  u.searchParams.set("nonce", nanoid())
  return u;
};

const getClasslinkHost = () => {
  if (isProd() || isStaging()) {
    return "https://launchpad.classlink.com/oauth2/v2/auth";
  }
  return "http://localhost.classlink:1236";
}
